import React from 'react';
import { formatNumber } from '../../utils/formatNumber';
import type { PlayerStats } from '../../types/gameState';

interface PlayerStatsTextBoxProps {
    stats: PlayerStats;
    commandPoints: {
        available: number;
        used: number;
        remaining: number;
    };
}

const PlayerStatsTextBox: React.FC<PlayerStatsTextBoxProps> = ({ stats, commandPoints }) => {
    // Helper function for icons
    const renderIcon = (icon: string) => (
        <span className="stats-icon">{icon}</span>
    );

    return (
        <div className="return-textbox stats-return-textbox">
            <div className="return-textbox-content">
                <div className="stats-grid">
                    <div className="stats-section">
                        <h3 className="stats-heading">Current Activity</h3>
                        <p className="stats-text">
                            <span className="stats-label">Total Ore Mined:</span>
                            <span className="stats-value">{formatNumber(stats.totalOreMined)}</span>
                        </p>
                        <p className="stats-text">
                            <span className="stats-label">Warps Made:</span>
                            <span className="stats-value">{stats.totalWarps}</span>
                        </p>
                        <p className="stats-text">
                            <span className="stats-label">Upgrades Purchased:</span>
                            <span className="stats-value">{stats.totalUpgradesPurchased}</span>
                        </p>
                        <p className="stats-text">
                            <span className="stats-label">Ships Recycled:</span>
                            <span className="stats-value">{stats.shipsRecycled}</span>
                        </p>
 
                    </div>

                    <div className="stats-section">
                        <h3 className="stats-heading">Current Fleet</h3>
                        <p className="stats-text">
                            <span className="stats-label">Total Ships:</span>
                            <span className="stats-value">{stats.totalShipsPurchased}</span>
                        </p>
                        <p className="stats-text">
                            <span className="stats-label">Mining Ships:</span>
                            <span className="stats-value">{stats.miningShipsPurchased}</span>
                        </p>
                        <p className="stats-text">
                            <span className="stats-label">Haulers:</span>
                            <span className="stats-value">{stats.haulerShipsPurchased}</span>
                        </p>
                        <p className="stats-text">
                            <span className="stats-label">Command Ships:</span>
                            <span className="stats-value">{stats.commandShipsPurchased}</span>
                        </p>
                    </div>


                    <div className="stats-section">
                        <h3 className="stats-heading">Prestige</h3>
                        <p className="stats-text">
                            <span className="stats-label">Level:</span>
                            <span className="stats-value">{stats.prestigeLevel}</span>
                        </p>
                        <p className="stats-text">
                            <span className="stats-label">Current Score:</span>
                            <span className="stats-value">{formatNumber(stats.currentPrestigeScore)}</span>
                        </p>
                        <p className="stats-text">
                            <span className="stats-label">Total Score:</span>
                            <span className="stats-value">{formatNumber(stats.totalScoreAllTime)}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlayerStatsTextBox;
